var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    fill: "#727272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M663.3,309.4c150.1,0,272.2,122.1,272.2,272.2c0,150.1-122.1,272.2-272.2,272.2S391.1,731.8,391.1,581.7C391.1,431.6,513.2,309.4,663.3,309.4 M663.3,255c-180.4,0-326.7,146.3-326.7,326.7c0,180.4,146.3,326.7,326.7,326.7S990,762.1,990,581.7C990,401.3,843.7,255,663.3,255L663.3,255z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.9,146.1h353.9v54.4H118.9V146.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.9,363.9h217.8v54.4H118.9V363.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.9,581.7h163.3v54.4H118.9L118.9,581.7L118.9,581.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.9,799.4h245v54.4h-245V799.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.3,608.9L663.3,608.9c-15,0-27.2-12.3-27.2-27.2V391.1c0-15,12.2-27.2,27.2-27.2l0,0c15,0,27.2,12.2,27.2,27.2v190.6C690.6,596.6,678.3,608.9,663.3,608.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.9,581.7L853.9,581.7c0,15-12.2,27.2-27.2,27.2H663.3c-15,0-27.2-12.2-27.2-27.2l0,0c0-15,12.2-27.2,27.2-27.2h163.3C841.7,554.4,853.9,566.6,853.9,581.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.7,200.6l-0.5-0.3c-1.3-17.6-10.7-33.6-25.9-42.8L567.4,17.8c-8.5-5.1-18.1-7.8-28-7.8H64.4C34.4,10,10,34.4,10,64.4v871.1c0,30.1,24.4,54.4,54.4,54.4h707.8c30.1,0,54.4-24.4,54.4-54.4v-27.2h-27.2v27.2c0,15-12.2,27.2-27.2,27.2H64.4c-15,0-27.2-12.2-27.2-27.2V64.4c0-15,12.2-27.2,27.2-27.2h462.8v108.9c0,30.1,24.4,54.4,54.4,54.4H799c0.2,1.2,0.5,2.4,0.5,3.6V255h27.2v-50.8c0-1.2-0.4-2.4-0.5-3.6H826.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterHistory);
export default __webpack_public_path__ + "static/media/letter-history.b4ef463a09b8adf2123faa74e907fdf7.svg";
export { ForwardRef as ReactComponent };